var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":_vm.loading,"height":"3"}}),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Complaints")])]),_c('v-card-text',[_c('v-btn',[_vm._v("Raise Complaint")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }